<wiz-hgroup
  #actionContainer
  height="100%"
  verticalAlign="center"
  style="padding: 5px"
  [wizDisabled]="owner.wizDisabled"
>
  <wiz-label [wizLabel]="orderAndlabel" width="100%"></wiz-label>

  <wiz-icon #iconUp *ngIf="mayUp()" [wizTooltip]="'$.vision.step.move.previous.$'" (click)="doUp($event)">arrow-up</wiz-icon>
  <wiz-icon #iconDown *ngIf="mayDown()" [wizTooltip]="'$.vision.step.move.next.$'"  (click)="doDown($event)">arrow-down</wiz-icon>
  
</wiz-hgroup>
